"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Quote } from "lucide-react";
const testimonials = [{
  id: 1,
  quote: "Oryx Fleet transformed our dispatching experience. Reliable, transparent, and always there when we need them.",
  author: "Michael Torres",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/testimonial_michael_torres.png"
}, {
  id: 2,
  quote: "Thanks to Oryx Fleet, I focus on driving while they handle all the logistics. Best decision I ever made.",
  author: "Sarah Martinez",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/testimonial_sarah_martinez.png"
}, {
  id: 3,
  quote: "Professional, efficient, and always negotiating the best rates. Oryx Fleet keeps me profitable on the road.",
  author: "David Chen",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/testimonial_david_chen.png"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section ref={ref} className="bg-[hsl(0,0%,95%)] py-24 px-4">
      <div className="mx-auto max-w-screen-xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, i) => <Card key={testimonial.id} data-index={i} className={`group relative flex flex-col items-center bg-background px-6 py-8 text-center shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-0.5 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
          animationDelay: isVisible ? `${i * 120}ms` : "0ms"
        }}>
              <Quote className="mb-4 size-10 text-primary transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:rotate-2" strokeWidth={1.5} />
              <CardContent className="flex flex-col items-center gap-4 px-0">
                <p className="text-foreground leading-relaxed">
                  {testimonial.quote}
                </p>
                <div className="mt-2 flex flex-col items-center gap-3">
                  <SafeHydrate><Avatar className="size-12">
                    <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                    <AvatarFallback className="bg-secondary text-foreground-secondary">
                      {testimonial.author.split(" ").map(n => n[0]).join("")}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <p className="font-semibold text-foreground">
                    {testimonial.author}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}